export default class PriceService {
    getFormattedPrice(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Ft';
    }
}
